import errors from './settings/errors';
import remapEvent from './services/remapping.service';
import { sendToDps } from './services/dps.service';
export { updateConfig } from './config';
// checks to see if '@octagon/public-analytics' is installed or not
// remap each event and send it to the public dps endpoint
import('@octagon/public-analytics')
    .then((api) => {
    api.subscribeToEvents((event) => {
        const eventUrl = remapEvent(event);
        eventUrl && sendToDps(eventUrl);
    });
})
    .catch((err) => {
    console.warn(errors.missingAnalyticsPackage);
});
//# sourceMappingURL=index.js.map